export enum EDropdownTriggerMode {
    Default = 'default',
    Icon = 'icon',
}
